export default __webpack_public_path__ + "static/media/hero-start.ecfe7a9c.png";